import React from "react";
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	Legend,
	ResponsiveContainer,
	Label,
} from "recharts";

// Define colors for the Pie chart
const COLORS = ["#33ABDA", "#B05788"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value }) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
			{`${(value).toFixed(2)}`}
		</text>
	);
};

const PieChartWithTicks = ({ data, chartKey }) => {

	function formatDataForPieChart(data) {
		return data?.flatMap(item => [
			{
				name: `${item[chartKey]} - Managed Spend`, // Label for managed spend
				value: parseFloat(item.managedSpend)   // Numeric value for managed spend
			},
			{
				name: `${item[chartKey]} - Non-Managed Spend`, // Label for non-managed spend
				value: parseFloat(item.nonManagedSpend)    // Numeric value for non-managed spend
			}
		]);
	}
	const spendByTopSupplier = formatDataForPieChart(data);
	const totalValue = spendByTopSupplier.reduce((acc, item) => acc + item.value, 0);

	return (
		<ResponsiveContainer width="100%" height={300}>
			<PieChart>
				<Pie
					data={spendByTopSupplier}
					dataKey="value"
					nameKey="name"
					cx="50%"
					cy="50%"
					// innerRadius={60}
					// outerRadius={80}
					fill="#B05788"
					labelLine={false}
					//paddingAngle={5}
					label={renderCustomizedLabel}
				>
					{data.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
					))}
				</Pie>
			</PieChart>
		</ResponsiveContainer>
	);
};

export default PieChartWithTicks;
